var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheatsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 358,
    viewBox: "0 0 454 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_409_113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 448,
    height: 352,
    rx: 31,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 59H451V321C451 338.121 437.121 352 420 352H34C16.8792 352 3 338.121 3 321V59Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 9,
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 29,
    r: 9,
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 29,
    r: 9,
    fill: "#FFBD44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 78H137C140.866 78 144 81.134 144 85V210C144 213.866 140.866 217 137 217H44C40.134 217 37 213.866 37 210V85C37 81.134 40.134 78 44 78Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316 78H409C412.866 78 416 81.134 416 85V210C416 213.866 412.866 217 409 217H316C312.134 217 309 213.866 309 210V85C309 81.134 312.134 78 316 78Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 78H273C276.866 78 280 81.134 280 85V163C280 166.866 276.866 170 273 170H180C176.134 170 173 166.866 173 163V85C173 81.134 176.134 78 180 78Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 247H137C140.866 247 144 250.134 144 254V352H37V254C37 250.134 40.134 247 44 247Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316 247H409C412.866 247 416 250.134 416 254V352H309V254C309 250.134 312.134 247 316 247Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180 200H273C276.866 200 280 203.134 280 207V352H173V207C173 203.134 176.134 200 180 200Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_409_113",
    x: 0,
    y: 0,
    width: 454,
    height: 358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_409_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_409_113",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheatsheet);
export default __webpack_public_path__ + "static/media/cheatsheet.f6a9da0d76098b3413607b43504278ae.svg";
export { ForwardRef as ReactComponent };